import { CoreIcon } from '../core-icon';
import filterSVG from '../../assets/icons/filter.svg';
import type { IconProps } from '../core-icon';

export const FilterIcon = (props: Omit<IconProps, 'src'>) => {
  return <CoreIcon src={filterSVG} {...props} />;
};
